// The plan tiers and the entitlements each includes. Gates resolve the tier
// from the config.plan_tier flag rather than the account's own entitlements.
// Keep in sync with config/entitlements.yml and app/models/plan_tier.rb (a test
// checks).
export type PlanTier = "essentials" | "business" | "premium";

export const DEFAULT_PLAN_TIER: PlanTier = "premium";

const ESSENTIALS = [
  "customizable-templates",
  "professional-services-scoping",
  "chat-and-email-support",
  "autotask-integration",
];

const BUSINESS = [
  ...ESSENTIALS,
  "phone-support",
  "salesforce-integration",
  "psa-integration",
  "docusign-integration",
  "managed-services-scoping",
  "watermarking",
  "product-quoting",
  "3rd-party-scoping",
];

const PREMIUM = [
  ...BUSINESS,
  "recommendation-engine",
  "terms-and-conditions",
  "workflow-approval",
  "multi-currency",
  "rate-table-management",
  "scopestack-connect",
  "advanced-pricing",
];

export const PLAN_TIER_ENTITLEMENTS: Readonly<
  Record<PlanTier, readonly string[]>
> = Object.freeze({
  essentials: Object.freeze(ESSENTIALS),
  business: Object.freeze(BUSINESS),
  premium: Object.freeze(PREMIUM),
});

// An unknown or missing flag value falls back to the default tier.
export const resolvePlanTier = (value: unknown): PlanTier =>
  typeof value === "string" &&
  Object.prototype.hasOwnProperty.call(PLAN_TIER_ENTITLEMENTS, value)
    ? (value as PlanTier)
    : DEFAULT_PLAN_TIER;

export const planTierEntitlements = (value: unknown): readonly string[] =>
  PLAN_TIER_ENTITLEMENTS[resolvePlanTier(value)];
